const money = (v) => (Number(v) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const date = (iso) => (iso ? new Date(iso.length === 10 ? `${iso}T12:00:00` : iso).toLocaleDateString('pt-BR') : '-');
const STATUS = { pendente: 'Pendente', parcial: 'Parcial', vencido: 'Vencido', pago: 'Pago', cancelado: 'Cancelado' };

export function buildPayablesReportHtml(rel) {
  const { empresa = {}, filtros = {}, fornecedores = [], totais = {} } = rel;
  const periodo = filtros.de || filtros.ate
    ? `${filtros.de ? date(filtros.de) : 'início'} a ${filtros.ate ? date(filtros.ate) : 'hoje'}`
    : 'Todo o período';

  const rows = fornecedores.map((c) => `
    <tbody class="cliente">
      <tr class="cliente-head"><td colspan="7">${c.fornecedor_nome}</td></tr>
      ${c.itens.map((i) => `
        <tr>
          <td>${i.categoria || '-'}${i.descricao ? ` — ${i.descricao}` : ''}</td>
          <td>${date(i.data_emissao)}</td>
          <td>${date(i.data_vencimento)}</td>
          <td class="num">${money(i.valor_original)}</td>
          <td class="num">${money(i.valor_pago)}</td>
          <td class="num">${money(i.valor_restante)}</td>
          <td><span class="st st-${i.status}">${STATUS[i.status] || i.status}</span></td>
        </tr>`).join('')}
      <tr class="cliente-total">
        <td colspan="3">Subtotal ${c.fornecedor_nome}</td>
        <td class="num">${money(c.original)}</td>
        <td class="num">${money(c.pago)}</td>
        <td class="num">${money(c.restante)}</td>
        <td>${c.vencido > 0 ? `<span class="st st-vencido">Vencido ${money(c.vencido)}</span>` : ''}</td>
      </tr>
    </tbody>`).join('');

  return `<!DOCTYPE html><html lang="pt-BR"><head><meta charset="utf-8">
<title>Relatório de Contas a Pagar - ${empresa.nome_fantasia || empresa.razao_social || ''}</title>
<style>
  *{box-sizing:border-box} body{font-family:Arial,Helvetica,sans-serif;color:#0f172a;margin:0;padding:28px;font-size:12px}
  header{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #0f172a;padding-bottom:12px;margin-bottom:16px}
  h1{margin:0;font-size:20px} .muted{color:#64748b} .meta{text-align:right;font-size:11px}
  .cards{display:grid;grid-template-columns:repeat(4,1fr);gap:10px;margin-bottom:18px}
  .card{border:1px solid #e2e8f0;border-radius:8px;padding:10px} .card b{display:block;font-size:15px;margin-top:2px}
  table{width:100%;border-collapse:collapse} th{background:#0f172a;color:#fff;text-align:left;padding:7px 8px;font-size:11px}
  td{padding:6px 8px;border-bottom:1px solid #e2e8f0} .num{text-align:right;white-space:nowrap}
  .cliente-head td{background:#f1f5f9;font-weight:bold;padding-top:9px} .cliente-total td{font-weight:bold;background:#f8fafc}
  .st{font-size:10px;padding:2px 6px;border-radius:10px;font-weight:bold}
  .st-pendente{background:#dbeafe;color:#1e40af}.st-parcial{background:#fef3c7;color:#92400e}.st-vencido{background:#ffe4e6;color:#9f1239}.st-pago{background:#d1fae5;color:#065f46}.st-cancelado{background:#e2e8f0;color:#475569}
  tfoot td{font-weight:bold;background:#0f172a;color:#fff;font-size:12px}
  .btn{position:fixed;top:12px;right:12px;background:#0f172a;color:#fff;border:0;padding:10px 16px;border-radius:8px;cursor:pointer;font-size:13px}
  footer{margin-top:18px;font-size:10px;color:#64748b;display:flex;justify-content:space-between}
  @media print{.btn{display:none} body{padding:0} .cliente{page-break-inside:avoid}}
</style></head><body>
<button class="btn" onclick="window.print()">Salvar em PDF / Imprimir</button>
<header>
  <div>
    <h1>Relatório de Contas a Pagar</h1>
    <div class="muted">${empresa.razao_social || ''}${empresa.nome_fantasia ? ` (${empresa.nome_fantasia})` : ''}</div>
    <div class="muted">${empresa.cnpj ? `CNPJ ${empresa.cnpj}` : ''}${empresa.telefone ? ` • ${empresa.telefone}` : ''}</div>
  </div>
  <div class="meta">
    <div><b>Período (vencimento):</b> ${periodo}</div>
    <div><b>Status:</b> ${filtros.status ? STATUS[filtros.status] : 'Todos'}</div>
    <div class="muted">Gerado em ${new Date(rel.gerado_em || Date.now()).toLocaleString('pt-BR')}</div>
  </div>
</header>
<div class="cards">
  <div class="card"><span class="muted">Títulos</span><b>${totais.count || 0}</b></div>
  <div class="card"><span class="muted">Valor original</span><b>${money(totais.original)}</b></div>
  <div class="card"><span class="muted">Pago</span><b style="color:#065f46">${money(totais.pago)}</b></div>
  <div class="card"><span class="muted">Em aberto (vencido)</span><b style="color:#9f1239">${money(totais.restante)} <small>(${money(totais.vencido)})</small></b></div>
</div>
<table>
  <thead><tr><th>Categoria / Descrição</th><th>Emissão</th><th>Vencimento</th><th class="num">Original</th><th class="num">Pago</th><th class="num">Restante</th><th>Status</th></tr></thead>
  ${rows || '<tbody><tr><td colspan="7" style="text-align:center;padding:24px" class="muted">Nenhuma conta encontrada para os filtros informados.</td></tr></tbody>'}
  <tfoot><tr><td colspan="3">TOTAL GERAL (${fornecedores.length} fornecedor${fornecedores.length === 1 ? '' : 'es'})</td><td class="num">${money(totais.original)}</td><td class="num">${money(totais.pago)}</td><td class="num">${money(totais.restante)}</td><td></td></tr></tfoot>
</table>
<footer><span>nfcesysPdv • Contas a Pagar</span><span>Documento gerado automaticamente para conferência contábil</span></footer>
</body></html>`;
}
